import { z } from 'zod'

export const VServerSnapshotStatus = z.enum(['creating', 'active', 'deleting', 'failed'])
export type VServerSnapshotStatus = z.infer<typeof VServerSnapshotStatus>

export const VServerSnapshot = z.object({
  name: z.string(),
  description: z.string().nullable().optional(),
  status: VServerSnapshotStatus,
  size_bytes: z.number().nullable().optional(),
  vmstate: z.boolean().optional(),
  // true = automatic safety snapshot (e.g. taken before a resize) the customer can restore from.
  auto: z.boolean().optional(),
  // Unix seconds, like the other VServer timestamps.
  created_at: z.number()
})
export type VServerSnapshot = z.infer<typeof VServerSnapshot>

export const VServerSnapshotCreateRequest = z.object({
  name: z.string().min(1).max(63),
  description: z.string().max(255).optional(),
  vmstate: z.boolean().optional()
})
export type VServerSnapshotCreateRequest = z.infer<typeof VServerSnapshotCreateRequest>
